import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemListForSelectController::__invoke
* @see app/Http/Controllers/Item/GetItemListForSelectController.php
* @route '/api/item-for-select'
*/
const GetItemListForSelectController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForSelectController.url(options),
    method: 'get',
})

GetItemListForSelectController.definition = {
    methods: ["get","head"],
    url: '/api/item-for-select',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemListForSelectController::__invoke
* @see app/Http/Controllers/Item/GetItemListForSelectController.php
* @route '/api/item-for-select'
*/
GetItemListForSelectController.url = (options?: RouteQueryOptions) => {
    return GetItemListForSelectController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemListForSelectController::__invoke
* @see app/Http/Controllers/Item/GetItemListForSelectController.php
* @route '/api/item-for-select'
*/
GetItemListForSelectController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForSelectController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemListForSelectController::__invoke
* @see app/Http/Controllers/Item/GetItemListForSelectController.php
* @route '/api/item-for-select'
*/
GetItemListForSelectController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemListForSelectController.url(options),
    method: 'head',
})

export default GetItemListForSelectController